/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';
import deptService from '../../services/DepartmentService';
import DeptTypes from '../types/DepartmentTypes';

//* get all department list items
function getAll(pageOption, sortData, keyword) {
  return async (dispatch) => {
    dispatch({ type: DeptTypes.GET_DEPARTMENT_LIST_REQUEST });
    try {
      const res = await deptService.getAll(pageOption, sortData, keyword);
      dispatch({
        type: DeptTypes.GET_DEPARTMENT_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: DeptTypes.GET_DEPARTMENT_LIST_ERROR,
          error: error.response
        });
      }
    }
  };
}

const updateQueryParams = (paginationModel, sortInfo, keyword) => ({
  type: DeptTypes.UPDATE_QUERY_PARAMS,
  payload: { paginationModel, sortInfo, keyword }
});

function add(postData, setErrors, submitting, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: DeptTypes.ADD_DEPARTMENT_REQUEST });
    try {
      const res = await deptService.add(postData);
      dispatch({ type: DeptTypes.ADD_DEPARTMENT_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().department.queryParams;
      setTimeout(() => dispatch(DeptAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      closeModal();
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: DeptTypes.ADD_DEPARTMENT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getItem(code) {
  return async (dispatch) => {
    dispatch({ type: DeptTypes.GET_DEPARTMENT_ITEM_REQUEST });
    try {
      const res = await deptService.getItem(code);
      dispatch({
        type: DeptTypes.GET_DEPARTMENT_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: DeptTypes.GET_DEPARTMENT_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function update(code, postData, setErrors, submitting, navigate) {
  return async (dispatch, getState) => {
    dispatch({ type: DeptTypes.UPDATE_DEPARTMENT_REQUEST });
    try {
      const res = await deptService.update(code, postData);
      dispatch({
        type: DeptTypes.UPDATE_DEPARTMENT_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      // console.log(getState(), 'dsfdsfsdfsdfsdfs');
      const { paginationData, sortingData, keyword } = getState().department.queryParams;
      setTimeout(() => dispatch(DeptAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      navigate('/');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: DeptTypes.UPDATE_DEPARTMENT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function deleteItem(code, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: DeptTypes.DELETE_DEPARTMENT_REQUEST });
    try {
      const res = await deptService.deleteItem(code);
      dispatch({
        type: DeptTypes.DELETE_DEPARTMENT_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().department.queryParams;
      setTimeout(() => dispatch(DeptAction.getAll(paginationData, sortingData, keyword)), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: DeptTypes.DELETE_DEPARTMENT_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function getActiveItem() {
  return async (dispatch) => {
    dispatch({ type: DeptTypes.GET_DEPARTMENT_ACTIVE_REQUEST });
    try {
      const res = await deptService.getActiveItem();
      dispatch({
        type: DeptTypes.GET_DEPARTMENT_ACTIVE_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: DeptTypes.GET_DEPARTMENT_ACTIVE_ERROR,
          error: error.response
        });
      }
    }
  };
}

const DeptAction = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getActiveItem,
  updateQueryParams
};

export default DeptAction;
